import { tv } from 'tailwind-variants'

export const searchInputVariants = tv({
  slots: {
    inputFace: 'bg-white w-full'
  }
})
